
<div class="cell small-6">
  <label>Type of Well:</label>
</div>
<div class="cell small-6">
  <select name="requestType" [(ngModel)]="seConfiguration.requestType">
    <option value="Application">Proposed (Application)</option>
    <option value="ApprovedPermit">Permitted</option>
  </select>
</div>

<div class="cell small-6">
  <label for="casingPlanContextExpression">Context Target of Casing Plan Object:</label>
</div>
<div class="cell small-6">
  <label class="cursor-pointer">
    <input type="text" id="casingPlanContextTarget" [(ngModel)]="seConfiguration.casingPlanContextTarget" />
  </label>
</div>

@if (seConfiguration.requestType == 'Application') {
  <div>
    <div class="cell small-6">
      <label>Application Number:</label>
    </div>
    <div class="cell small-6">
      <label class="cursor-pointer">
        <input type="text" name="applicationId" [(ngModel)]="seConfiguration.applicationIdExpression" />
      </label>
    </div>
  </div>
}

<div class="cell small-6">
  <label>API Number:</label>
</div>
<div class="cell small-6">
  <label class="cursor-pointer">
    <input type="text" name="apiNumber" [(ngModel)]="seConfiguration.apiNumberExpression" />
  </label>
</div>

<div class="cell small-6">
  <label>Organization ID:</label>
</div>
<div class="cell small-6">
  <label class="cursor-pointer">
    <input type="text" name="orgId" [(ngModel)]="seConfiguration.orgIdExpression" />
  </label>
</div>

<div class="cell small-6">
  <label>Well Type:</label>
</div>
<div class="cell small-6">
  <label class="cursor-pointer">
    <input type="text" name="wellType" [(ngModel)]="seConfiguration.wellTypeExpression" />
  </label>
</div>

<div class="cell small-6">
  <label>Well Type Description:</label>
</div>
<div class="cell small-6">
  <label class="cursor-pointer">
    <input type="text" name="wellTypeDescription" [(ngModel)]="seConfiguration.wellTypeDescriptionExpression" />
  </label>
</div>

<div class="cell small-6">
  <label>Well Disposition:</label>
</div>
<div class="cell small-6">
  <label class="cursor-pointer">
    <input type="text" name="wellDisposition" [(ngModel)]="seConfiguration.wellDispositionExpression" />
  </label>
</div>

<div class="cell small-6">
  <label>Well Disposition Legacy Tracking:</label>
</div>
<div class="cell small-6">
  <label class="cursor-pointer">
    <input type="text" name="wellDispositionLegacyTracking" [(ngModel)]="seConfiguration.wellDispositionLegacyTrackingExpression" />
  </label>
</div>

<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      Last Transfer Prior To June 2010?:
      <input type="text" name="lastTransferPriorToJune2010" [(ngModel)]="seConfiguration.lastTransferPriorToJune2010Expression" />
    </label>
  </div>
</div>

<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      Is Without Five Acres?:
      <input type="text" name="isWithoutFiveAcres" [(ngModel)]="seConfiguration.isWithoutFiveAcresExpression" />
    </label>
  </div>
</div>

<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      Has Release of Lease?:
      <input type="text" name="hasReleaseOfLease" [(ngModel)]="seConfiguration.hasReleaseOfLeaseExpression" />
    </label>
  </div>
</div>

<div class="cell small-6">
  <label>Well Name:</label>
</div>
<div class="cell small-6">
  <label class="cursor-pointer">
    <input type="text" name="name" [(ngModel)]="seConfiguration.nameExpression" />
  </label>
</div>

<div class="cell small-6">
  <label>Compliance:</label>
</div>
<div class="cell small-6">
  <label class="cursor-pointer">
    <input type="text" name="compliance" [(ngModel)]="seConfiguration.complianceExpression" />
  </label>
</div>

<div class="cell small-6">
  <label>Well ProposedFormations:</label>
</div>
<div class="cell small-6">
  <label class="cursor-pointer">
    <input type="text" name="proposedFormation" [(ngModel)]="seConfiguration.proposedFormationExpression" />
  </label>
</div>

<div class="cell small-6">
  <label>Original Spud Date:</label>
</div>
<div class="cell small-6">
  <label class="cursor-pointer">
    <input type="text" name="originalSpudDate" [(ngModel)]="seConfiguration.originalSpudDateExpression" />
  </label>
</div>

<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      Well Target Lat83:
      <input type="text" name="targetLat83" [(ngModel)]="seConfiguration.targetLat83Expression" />
    </label>
  </div>
</div>

<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      Well Target Long83:
      <input type="text" name="targetLong83" [(ngModel)]="seConfiguration.targetLong83Expression" />
    </label>
  </div>
</div>

<div class="cell small-6">
  <label>Well First Take Point Lat83:</label>
</div>
<div class="cell small-6">
  <label class="cursor-pointer">
    <input type="text" name="firstTakePointLat83" [(ngModel)]="seConfiguration.firstTakePointLat83Expression" />
  </label>
</div>

<div class="cell small-6">
  <label>Well First Take Point Long83:</label>
</div>
<div class="cell small-6">
  <label class="cursor-pointer">
    <input type="text" name="firstTakePointLong83" [(ngModel)]="seConfiguration.firstTakePointLong83Expression" />
  </label>
</div>

<div class="cell small-6">
  <label>Well Last Take Point Lat83:</label>
</div>
<div class="cell small-6">
  <label class="cursor-pointer">
    <input type="text" name="lastTakePointLat83" [(ngModel)]="seConfiguration.lastTakePointLat83Expression" />
  </label>
</div>

<div class="cell small-6">
  <label>Well Last Take Point Long83:</label>
</div>
<div class="cell small-6">
  <label class="cursor-pointer">
    <input type="text" name="lastTakePointLong83" [(ngModel)]="seConfiguration.lastTakePointLong83Expression" />
  </label>
</div>

<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      Well Number:
      <input type="text" name="number" [(ngModel)]="seConfiguration.numberExpression" />
    </label>
  </div>
</div>


<div class="cell small-12 checkbox small-font-size">
  <label for="showCasingPlanAttributeFields">
    Do you want to use the casingplan for any applicable attributes, as opposed to specifying them manually?
  </label>
</div>
<div class=" cell small-6">
  <input type="checkbox" id="showCasingPlanAttributeFields" [(ngModel)]="seConfiguration.useCasingPlanForRelevantValues" />
</div>

<!--The following fields are currently being pulled from the casing plan object, leaving this here in case they ever need configured independently at some point-->
@if (!seConfiguration.useCasingPlanForRelevantValues) {
  <div>
    <div class="grid-x grid-margin-x">
      <div class="cell small-12">
        <label>
          Well Head Lat83 (can come from casing plan):
          <input type="text" name="lat83" [(ngModel)]="seConfiguration.wellHeadLat83Expression" />
        </label>
      </div>
    </div>
    <div class="grid-x grid-margin-x">
      <div class="cell small-12">
        <label>
          Well Head Long83 (can come from casing plan):
          <input type="text" name="long83" [(ngModel)]="seConfiguration.wellHeadLong83Expression" />
        </label>
      </div>
    </div>
    <div class="grid-x grid-margin-x">
      <div class="cell small-12">
        <label>
          Is Permitted Urban? (can come from casing plan):
          <input type="text" name="isPermittedUrban" [(ngModel)]="seConfiguration.isPermittedUrbanExpression" />
        </label>
      </div>
    </div>
    <div class="grid-x grid-margin-x">
      <div class="cell small-12">
        <label>
          Depth (can come from casing plan):
          <input type="text" name="depth" [(ngModel)]="seConfiguration.depthExpression" />
        </label>
      </div>
    </div>
    <div class="grid-x grid-margin-x">
      <div class="cell small-12">
        <label>
          Well Slant: (Vertical, Directional, Horizontal, Other Horizontal) (can come from casing plan):
          <input type="text" name="slant" [(ngModel)]="seConfiguration.slantExpression" />
        </label>
      </div>
    </div>
  </div>
}